import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import Camera, { FACING_MODES } from 'react-html5-camera-photo'
import { MdSwitchCamera as MdLoop } from 'react-icons/md'
import { MdClose } from 'react-icons/md'
import Button from '@orionx-dev/orionsoft-parts/lib/components/Button'
import 'react-html5-camera-photo/build/css/index.css'

const CameraComponent = ({ onChange, onClose, overlay, fieldName }) => {
  const [cameraRevert, setCameraRevert] = useState(false)
  const [tookPhoto, setTookPhoto] = useState(false)
  const [cameraImage, setCameraImage] = useState(false)

  const setOverlay = () => {
    const element = document.getElementById('white-flash')
    if (element) {
      element.style.background = `url("${overlay}") no-repeat center/contain`
    }
  }

  const isMobile = () => window.innerWidth < 600

  const cameraModeInterface = () => {
    return cameraRevert ? FACING_MODES.USER : FACING_MODES.ENVIRONMENT
  }

  const uploadCamPhoto = async () => {
    const request = await fetch(cameraImage)
    const file = await request.blob()
    const now = new Date()
    file.lastModifiedDate = now
    file.lastModified = now.getTime()
    file.name = `${file.lastModified}_CAMERA_UPLOAD.png`
    onChange(file)
    onClose()
  }

  const handleCameraRevert = () => {
    setCameraRevert(!cameraRevert)
  }

  const handleTakePhoto = dataUri => {
    setTookPhoto(true)
    setCameraImage(dataUri)
  }

  const handleRetryPhoto = () => {
    setTookPhoto(false)
    setCameraImage(false)
  }

  const getInstruction = () => {
    if (fieldName === 'selfie') {
      return 'Toma una selfie con tu dispositivo'
    } else if (fieldName === 'identityDocumentFront') {
      return 'Toma una foto delantera de tu documento de identidad'
    } else if (fieldName === 'identityDocumentBack') {
      return 'Toma una foto trasera de tu documento de identidad'
    }
    return 'Toma foto con tu dispositivo'
  }

  const renderAcceptImage = () => {
    return (
      <div>
        <Button big primary className="tds-orionx-override-btn" onClick={uploadCamPhoto}>
          Guardar
        </Button>
        <Button
          big
          className="tds-orionx-override-btn tds-orionx-override-btn--ghost"
          onClick={handleRetryPhoto}>
          Repetir
        </Button>
      </div>
    )
  }

  const renderImagePreview = () => {
    if (!tookPhoto) return null
    return (
      <div className={styles.imagePreview}>
        <img alt="preview camera upload" src={cameraImage} />
        <div className={`${styles.imageValidator} ${styles.validateImgButtons}`}>
          {renderAcceptImage()}
        </div>
      </div>
    )
  }

  const renderTitle = () => {
    if (!tookPhoto) {
      return <p className={styles.cameraText}>{getInstruction()}</p>
    }
    return <p className={styles.cameraText}>¿Estás conforme con la foto?</p>
  }

  const renderCamera = () => {
    if (tookPhoto) return null

    let cameraProps = {}
    if (isMobile()) {
      cameraProps = {
        idealFacingMode: cameraModeInterface(),
        isImageMirror: false,
        onTakePhotoAnimationDone: handleTakePhoto,
      }
    } else {
      cameraProps = {
        isMaxResolution: false,
        idealFacingMode: FACING_MODES.ENVIRONMENT,
        isImageMirror: false,
        onTakePhotoAnimationDone: handleTakePhoto,
      }
    }

    return <Camera {...cameraProps} onCameraStart={setOverlay} />
  }

  const renderCameraRevert = () => {
    if (!isMobile() || tookPhoto) return null
    return (
      <div onClick={handleCameraRevert} className={styles.revertIconContainer}>
        <MdLoop className={styles.icon} />
      </div>
    )
  }

  return (
    <div className={`${styles.modalLayout} ${styles.modalContainer} ${styles.cameraContainer}`}>
      <div className={styles.closeIconContainer}>
        <MdClose onClick={onClose} className={styles.icon} />
      </div>
      {renderTitle()}
      <div className={styles.camera}>
        {renderImagePreview()}
        {renderCamera()}
        {renderCameraRevert()}
      </div>
    </div>
  )
}

CameraComponent.propTypes = {
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  overlay: PropTypes.string,
  fieldName: PropTypes.string,
}

export default CameraComponent
